import { useCallback, useEffect, useState } from "react";
import { getCompanyAccessName } from "../App";

const useFetchPaginatedElements = (companyAccessname, type, page = 1, pageSize = 10) => {
  const [data, setData] = useState({
    loading: true,
    error: null,
    totalPages: 1,
    pageSize: pageSize,
    page: page,
    stories: [],
    jobs: [],
    events: [],
    medien: [],
    firmendaten: [],
    ansprechpartner: [],
  });


  const buildFetchUrl = useCallback(() => {
    const resolvedCompanyAccessname = companyAccessname || getCompanyAccessName();
    if (!resolvedCompanyAccessname || !type) {
      return null;
    }

    // Sicherstellen, dass pageSize eine gültige Zahl ist
    const validPageSize = pageSize > 0 ? pageSize : 10;

    const baseUrl = process.env.API_BASE_URL + `/pcw/${resolvedCompanyAccessname}`;
    const endpoints = {
      firmendaten: `${baseUrl}/companyinfo`,
      ansprechpartner: `${baseUrl}/contacts/page/${page}/pageSize/${validPageSize}`,
      events: `${baseUrl}/events/page/${page}/pageSize/${validPageSize}`,
      jobs: `${baseUrl}/jobs/page/${page}/pageSize/${validPageSize}`,
      stories: `${baseUrl}/stories/page/${page}/pageSize/${validPageSize}`,
      medien: `${baseUrl}/media/page/${page}/pageSize/${validPageSize}`,
    };

    return endpoints[type] || null;
  }, [companyAccessname, type, page, pageSize]);

  useEffect(() => {
    const fetchData = async () => {
      const fetchUrl = buildFetchUrl();
      if (!fetchUrl) {
        setData((prevData) => ({
          ...prevData,
          loading: false,
          error: "Invalid fetch parameters",
        }));

        return;
      }

      setData((prevData) => ({ ...prevData, loading: true, error: null }));

      try {
        const response = await fetch(fetchUrl, { mode: "cors" });

        if (!response.ok) {
          throw new Error(`Failed to fetch data: ${response.status} ${response.statusText}`);
        }

        const jsonData = await response.json();

        setData((prevData) => {
          let newData = {};

          if (Array.isArray(jsonData)) {
            newData[type] = jsonData;
          } else if (typeof jsonData === "object" && jsonData !== null) {
            newData[type] = jsonData[type] || jsonData;
          } else {
            newData[type] = [];
          }

          // Sicherstellen, dass totalPages einen Standardwert hat
          const totalPages = jsonData.meta?.totalPages ?? 1;

          return {
            ...prevData,
            loading: false,
            error: null,
            totalPages,
            ...newData,
          };
        });
      } catch (error) {
        setData((prevData) => ({
          ...prevData,
          loading: false,
          error: error.message || "An unknown error occurred",
        }));
      }
    };

    fetchData();
  }, [buildFetchUrl]);

  return data;
};

export default useFetchPaginatedElements;
